"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputPhone = void 0;
const react_1 = __importDefault(require("react"));
const react_phone_input_2_1 = __importDefault(require("react-phone-input-2"));
const input_phone_lang_ru_1 = __importDefault(require("./input-phone-lang-ru"));
const input_phone_styled_1 = require("./input-phone.styled");
const input_phone_2_styled_1 = require("./input-phone-2.styled");
function InputPhone(_a) {
    var { label = 'Номер телефона', name, value, onChange, onBlur = () => { }, error, disabled = false, type = 'text', notion, required, colors, children } = _a, props = __rest(_a, ["label", "name", "value", "onChange", "onBlur", "error", "disabled", "type", "notion", "required", "colors", "children"]);
    const handleInputChange = (e) => {
        onChange && onChange(`+${e}`);
    };
    return (react_1.default.createElement("div", { style: {
            ['--primary-color']: (colors === null || colors === void 0 ? void 0 : colors.primary) ? colors === null || colors === void 0 ? void 0 : colors.primary : '#367BF5',
            ['--primary-hover-color']: (colors === null || colors === void 0 ? void 0 : colors.primaryHover) ? colors === null || colors === void 0 ? void 0 : colors.primaryHover : '#E1EBFD',
            ['--error-color']: (colors === null || colors === void 0 ? void 0 : colors.error) ? colors === null || colors === void 0 ? void 0 : colors.error : '#e73030',
            ['--black']: (colors === null || colors === void 0 ? void 0 : colors.black) ? colors === null || colors === void 0 ? void 0 : colors.black : '#212121',
            opacity: disabled ? 0.5 : 1,
        } },
        react_1.default.createElement(input_phone_styled_1.StyledField, null,
            react_1.default.createElement(input_phone_styled_1.StyledWrappedInput, { disabled: disabled, className: error ? 'error' : '' },
                react_1.default.createElement(input_phone_2_styled_1.StyledInputPhoneWrapper, null,
                    react_1.default.createElement(react_phone_input_2_1.default, Object.assign({}, props, { inputProps: {
                            name,
                            required,
                        }, value: value, disabled: disabled, onChange: handleInputChange, onBlur: onBlur, country: "ru", localization: input_phone_lang_ru_1.default })))),
            react_1.default.createElement(input_phone_styled_1.StyledLabel, { disabled: disabled, className: "label" },
                label,
                required && react_1.default.createElement(input_phone_styled_1.StyledRequiredStar, null, "*")),
            react_1.default.createElement(input_phone_styled_1.StyledNotion, { hasError: error }, error || notion || children))));
}
exports.InputPhone = InputPhone;
//# sourceMappingURL=input-phone.js.map